<awair-floor-plan-list-item *ngFor="let deviceWithUuidAndStatus of devicesWithUuidAndStatus"
                            [width]="'262px'"
                            [height]="'48px'"
                            [mainText]="deviceWithUuidAndStatus?.deviceName"
                            [subText]="deviceWithUuidAndStatus?.floorName"
                            awairDraggable
                            [zone]="'editor-device'"
                            [data]="{deviceUuid: deviceWithUuidAndStatus?.uuid, deviceName: deviceWithUuidAndStatus?.deviceName}"
                            [imgSrc]="'assets/images/floor-plan/ic_marker-online.svg'">
  <awair-index-dot left
                   class="__dot"
                   [color]="'#64c2e6'"
                   [width]="'10px'"
                   [height]="'10px'">
  </awair-index-dot>
  <awair-pin-icon *ngIf="deviceWithUuidAndStatus?.isSelected"
                  right
                  [color]="'#868D94'">
  </awair-pin-icon>
</awair-floor-plan-list-item>
